import { Dimension } from '@pubstack/common/src/analytics/dimension'
import { AnalyticsQueryDashboard, MappedName, SiteMetricsByTagId } from '@pubstack/common/src/analytics/query'
import { useAtomValue } from 'jotai'
import { FunctionComponent } from 'react'
import { createSearchParams, useNavigate } from 'react-router-dom'
import { useAnalyticsQueryTanstack } from '~/api/analytics/analytics-query.api'
import { useBreadcrumbs } from '~/hooks/useBreadcrumbs'
import { useScopeCurrency } from '~/hooks/useScopeCurrency.hooks'
import { AnalyticsPage } from '~/modules/analytics/AnalyticsPage'
import { contextState } from '~/state'
import { PureSitesOverviewTable } from './PureSitesOverviewTable'

const DIMENSIONS: Dimension[] = ['tagId', 'bidder', 'adUnit', 'device', 'country', 'size', 'pubstackRefresh', 'abTestPopulation', 'stackIdVersion']
const DASHBOARD: AnalyticsQueryDashboard = { name: 'sites', filterType: 'auctions' }
const DATE_PARAMETER_FORMAT = 'yyyy-MM-dd'

export const SitesOverviewPage: FunctionComponent = () => {
  const context = useAtomValue(contextState)
  const analyticsQuery = useAnalyticsQueryTanstack<SiteMetricsByTagId>('site.metrics.by.tagid', DIMENSIONS, context, {})
  const currencySymbol = useScopeCurrency()

  const navigate = useNavigate()

  const onRowClick = (name: MappedName) => {
    navigate({
      pathname: `/analytics/sites/${name.label.replace(/[./]/g, '-')}`,
      search: `${createSearchParams({
        from: context.timeRange.from.toFormat(DATE_PARAMETER_FORMAT),
        to: context.timeRange.to.toFormat(DATE_PARAMETER_FORMAT),
        mapping: btoa(JSON.stringify({ site: name.value, siteName: name.label })), //TODO: tmu 2022-07-11 don't give out the tagid/sitename this way ?
      })}`,
    })
  }

  const breadcrumbs = useBreadcrumbs()
  return (
    <AnalyticsPage
      onRefreshClick={() => {
        analyticsQuery.refetch()
      }}
      filterDimensions={DIMENSIONS}
      dashboard={DASHBOARD}
      title={breadcrumbs}
    >
      <PureSitesOverviewTable
        onRowClick={onRowClick}
        onRefreshClick={() => {
          analyticsQuery.refetch()
        }}
        currencySymbol={currencySymbol}
        rawData={analyticsQuery.data}
        empty={!analyticsQuery.isFetching && !analyticsQuery?.data?.name.length}
        error={!!analyticsQuery.error}
        isLoading={analyticsQuery.isFetching}
        onSortChange={() => {}}
      />
    </AnalyticsPage>
  )
}
